import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

const compactStyles = css`
  padding: 4px 8px;
  font-size: ${11 / 16}rem;
  gap: 6px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    padding: 3px 6px;
    font-size: ${10 / 16}rem;
    gap: 4px;
  }
`;

const prominentStyles = css`
  padding: 10px 14px;
  font-size: ${13 / 16}rem;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 12px 16px;
    font-size: ${14 / 16}rem;
  }
`;

export const BadgeRoot = styled.div<{ $variant: "compact" | "prominent" }>`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  border-radius: ${({ $variant }) => ($variant === "compact" ? "6px" : "10px")};
  background-color: ${({ theme }) => theme.palette.secondary.orange50};
  border: 1px solid ${({ theme }) => theme.palette.secondary.orange200};
  color: ${({ theme }) => theme.palette.secondary.orange700};
  font-weight: 600;
  line-height: 1.3;

  ${({ $variant }) => ($variant === "compact" ? compactStyles : prominentStyles)}
`;

export const ProgramLabel = styled.span<{ $variant: "compact" | "prominent" }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.palette.secondary.orange700};

  ${({ $variant }) =>
    $variant === "prominent" &&
    css`
      font-size: ${12 / 16}rem;

      @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        font-size: ${13 / 16}rem;
      }
    `}
`;

export const ProgramFullName = styled.span`
  font-weight: 500;
  text-transform: none;
  letter-spacing: normal;
  color: ${({ theme }) => theme.palette.greyscale.grey800};
`;

export const LearnMoreLink = styled(Link)<{ $variant: "compact" | "prominent" }>`
  color: ${({ theme }) => theme.palette.primary.blue700};
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
  white-space: nowrap;

  &:hover,
  &:focus-visible {
    color: ${({ theme }) => theme.palette.primary.blue900};
  }

  ${({ $variant }) =>
    $variant === "compact"
      ? css`
          font-size: ${10 / 16}rem;

          @media (max-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
            font-size: ${9 / 16}rem;
          }
        `
      : css`
          font-size: ${12 / 16}rem;

          @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
            font-size: ${13 / 16}rem;
          }
        `}
`;

export const CardOverlay = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 3;
  max-width: calc(100% - 16px);
  pointer-events: none;

  ${BadgeRoot} {
    pointer-events: auto;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    top: 6px;
    left: 6px;
    max-width: calc(100% - 12px);
  }
`;
